import React from 'react';
import './Hero.css';

const MILESTONES = [
  { week: 'W01', label: 'Scoping & strategy call', tag: 'kickoff' },
  { week: 'W02', label: 'CRM audit + site build starts', tag: 'crm · dev' },
  { week: 'W06', label: 'New site live, campaigns launched', tag: 'launch' },
  { week: 'W12', label: 'Pipeline reporting & iteration', tag: 'growth' },
];

export default function Hero() {
  return (
    <header className="hero" id="top">
      <div className="hero-bg" aria-hidden="true">
        <div className="hero-aurora hero-aurora-1" />
        <div className="hero-aurora hero-aurora-2" />
        <div className="hero-grid" />
      </div>

      <div className="hero-inner">
        <div className="hero-copy">
          <div className="hero-badge hero-rise hero-rise-1">
            <span className="hero-badge-dot" />
            AI · SOFTWARE · MARKETING · CRM
          </div>
          <h1 className="hero-title hero-rise hero-rise-2">
            Build it. <span className="hero-title-accent">Market it.</span> Grow it. One partner.
          </h1>
          <p className="hero-subtext hero-rise hero-rise-3">
            Roonbash brings AI, engineering, marketing, and CRM expertise under one roof, so your product,
            your pipeline, and your growth all move together.
          </p>
          <div className="hero-ctas hero-rise hero-rise-4">
            <a href="#contact" className="btn btn-primary" data-magnetic>
              Start a project
            </a>
            <a href="#services" className="btn btn-secondary" data-magnetic>
              See what we do
            </a>
          </div>
        </div>

        <div className="hero-card-wrap hero-rise hero-rise-5">
          <div className="hero-card-float">
            <div className="hero-card" data-tilt>
              <div className="hero-card-header">
                <span>YOUR QUARTER WITH ROONBASH</span>
                <span className="hero-card-dot" />
              </div>
              <div className="hero-card-body">
                {MILESTONES.map((m) => (
                  <div className="hero-milestone" data-pipe-row key={m.week}>
                    <span className="hero-milestone-week">{m.week}</span>
                    <span className="hero-milestone-label">{m.label}</span>
                    <span className="hero-milestone-tag">{m.tag}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
